import { Button, Card, Divider, Icon } from '@blueprintjs/core';
import React from 'react';
import { useSelector } from 'react-redux';
import { RootState } from '../../../stores';
import SidebarArrowButton from '../../elements/SidebarArrowButton';
import SidebarButton from '../../elements/SidebarButton';
import useLogout from '../../hooks/useLogout';
import styles from './sidebar.module.css';
import {
  canViewBerkas,
  canViewPenugasan,
  canViewSurvey,
  canViewPenggambaran,
  canViewOverlay,
  canViewPengesahan,
  canViewPengiriman,
  canViewConfig,
  canViewUser,
} from '../../../utils/roles/slidebar/default';
import {
  getLinkByUserRole,
} from './data';

interface SidebarProps {
  collapsed?: boolean,
  onCollapse: () => void,
  /** Tampil di dalam drawer mobile: tanpa tombol collapse, dengan info akun & log out. */
  mobile?: boolean,
}

const Sidebar: React.FC<SidebarProps> = ({ collapsed, onCollapse, mobile }) => {
  const { user } = useSelector((s: RootState) => s.user);
  const logout = useLogout();

  return (
    <Card className={[styles.root, mobile && styles.mobile].filter(Boolean).join(' ')} elevation={1}>
      {mobile && (
        <div className={styles.account}>
          <Icon icon="user" />
          <span>{user.name}</span>
        </div>
      )}
      <div className={styles.menu}>
        <SidebarButton collapse={collapsed} href="#/dashboard" icon="dashboard">
          Dashboard
        </SidebarButton>
        {canViewBerkas(user) && (
          <SidebarButton collapse={collapsed} href="#/berkas" icon="projects">
            Berkas
          </SidebarButton>
        )}
        {canViewPenugasan(user) && (
          <SidebarButton collapse={collapsed} href="#/penugasan" icon="hand-right">
            Penugasan
          </SidebarButton>
        )}
        {canViewSurvey(user) && (
          <SidebarButton collapse={collapsed} href="#/survey" icon="path-search">
            Survey
          </SidebarButton>
        )}
        {canViewPenggambaran(user) && (
          <SidebarButton collapse={collapsed} href="#/penggambaran" icon="map">
            Penggambaran
          </SidebarButton>
        )}
        {canViewOverlay(user) && (
          <SidebarButton collapse={collapsed} href="#/overlay" icon="geosearch">
            Overlay
          </SidebarButton>
        )}
        {canViewPengesahan(user) && (
          <SidebarButton
            collapse={collapsed} href={getLinkByUserRole(user)} icon="saved">
            Pengesahan
          </SidebarButton>
        )}
        {canViewPengiriman(user) && (
          <SidebarButton collapse={collapsed} href="#/pengiriman" icon="cargo-ship">
            Pengiriman
          </SidebarButton>
        )}
        <SidebarButton collapse={collapsed} href="#/reports" icon="timeline-line-chart">
          Reports
        </SidebarButton>
        {canViewConfig(user) &&
          <SidebarButton collapse={collapsed} href="#/config" icon="cog">
            Configuration
          </SidebarButton>

        }
        {canViewUser(user) && (
          <SidebarButton collapse={collapsed} href="#/users" icon="people">
            User Management
          </SidebarButton>
        )}
      </div>

      <div className={styles.footer}>
        <Divider style={{ margin: 0 }} />

        {mobile ? (
          <div className={styles.logout}>
            <Button fill minimal alignText="left" icon="log-out" text="Log out" onClick={logout} />
          </div>
        ) : (
          <div className={styles.collapseRow}>
            <SidebarArrowButton
              icon={collapsed ? 'double-chevron-right' : 'double-chevron-left'}
              onClick={onCollapse}
              ali="left"
              label={collapsed ? 'Expand sidebar' : 'Collapse sidebar'}
            >
              {collapsed ? ' ' : 'Collapse'}
            </SidebarArrowButton>
          </div>
        )}
      </div>
    </Card>
  );
};

export default Sidebar;
